export default __webpack_public_path__ + "static/media/google-pay.c552fc50.png";